<template>
  <FusionBaseDialog
    :open="open"
    @close="close"
    :persistentOverlay="true"
    padded
    customCss="pop-up-message-dialog"
  >
    <template v-slot:header>
      <v-card-item>
        <v-card-title data-cy="popUpMessageHeader">
          {{ title }}
        </v-card-title>
      </v-card-item>
    </template>
    <div v-if="messages && messages.length" data-cy="popUpMessageContent">
      <p v-for="(message, index) in messages" :key="index">{{ message }}</p>
    </div>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="close"
        class="bg-primary text-white"
        variant="text"
        data-cy="popUpMessageDone"
        >{{ $t('buttons.done') }}</v-btn
      >
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PopUpMessageDialog',
  props: {
    open: Boolean,
    title: String,
    messages: Array
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close')
    }
  }
})
</script>
